import api from './axios';

export interface TimeContext {
  utcNow: string;
  businessNow: string;
  businessToday: string;
  businessTimezone: string;
}

export async function getTimeContext(): Promise<TimeContext> {
  const response = await api.get('/api/time-context');
  return response.data as TimeContext;
}
